import React from 'react';
import TableManager from '../components/data/TableManager';

const columnConfig = [
  "PAR_Id_Parametri=1,ID",
  "PAR_Codice=2,Codice",
  "PAR_Descrizione=2,Descrizione",
  "PAR_Ordinamento=2,Ordinamento,type=number",
  "PAR_NomeGruppo=2,Nome Gruppo",
  "PAR_InizioValidita=1,Inizio Validità,type=datetime",
  "PAR_FineValidita=1,Fine Validità,type=datetime",
  "PAR_StatiRecord=2,Stato Record", // Lookup gestito da lookupConfig
  "PAR_Utente=0,Utente Audit",
  "PAR_Terminale=0,Terminale Audit",
  "PAR_Timestamp=0,Timestamp DB"
];

const filterConfig = [
  { field: 'PAR_Codice', label: 'Codice', type: 'text' },
  { field: 'PAR_Descrizione', label: 'Descrizione', type: 'text' },
  { field: 'PAR_NomeGruppo', label: 'Nome Gruppo', type: 'text' },
  { field: 'PAR_StatiRecord', label: 'Stato Record', type: 'lookup', lookupName: 'statiRecordChar' },
];

const lookupConfig = {
  statiRecordChar: {
    options: [
      { value: 'A', label: 'Attivo' },
      { value: 'S', label: 'Sospeso' },
      { value: 'D', label: 'Disattivo' },
    ],
  }
};

const inputTypes = {
  PAR_Descrizione: 'textarea',
  PAR_InizioValidita: 'datetime-local',
  PAR_FineValidita: 'datetime-local',
  PAR_Ordinamento: 'number',
};

const ParametriPage = () => {
  return (
    <TableManager
      tableName="DOM_Parametri"
      primaryKey="PAR_Id_Parametri"
      pageTitle="Gestione parametri"
      columnConfig={columnConfig}
      filterConfig={filterConfig}
      lookupConfig={lookupConfig}
      inputTypes={inputTypes}
      enableCreate={true}
      enableEdit={true}
      enableDelete={true}
    />
  );
};

export default ParametriPage;